export interface OfferingCourse {
  id: number;
  title: string;
  slug: string;
  description: string;
  image: string;
  link: string;
   longDescription: string;
    longDescriptionSecond?:string
}

export const offeringCourses: OfferingCourse[] = [
  {
    id: 1,
    title: "Early Learning Center",
    slug: "early-learning-center",
    description:
      "A nurturing environment where young children begin their educational journey through play-based learning, creativity, and social interaction. We focus on building strong foundations in communication, motor skills, and curiosity.",
    image: "/images/offers/offering_early_learning_center.webp",
    link: "/#",
    longDescription:
     "A nurturing environment where young children begin their educational journey through play-based learning, creativity, and social interaction. We focus on building strong foundations in communication, motor skills, and curiosity.",
    longDescriptionSecond: "A nurturing environment where young children begin their educational journey through play-based learning, creativity, and social interaction. We focus on building strong foundations in communication, motor skills, and curiosity.",
  },
  {
    id: 2,
    title: "Primary Division",
    slug: "primary-division",
    description:
      "Our Primary Division focuses on developing core academic skills, critical thinking, and confidence. Students are encouraged to explore, ask questions, and build a strong base in subjects like mathematics, language, and science.",
    image: "/images/offers/offering_Primary_class.webp",
    link: "/#",
    longDescription:
     "Our Primary Division focuses on developing core academic skills, critical thinking, and confidence. Students are encouraged to explore, ask questions, and build a strong base in subjects like mathematics, language, and science.",
    longDescriptionSecond: "Our Primary Division focuses on developing core academic skills, critical thinking, and confidence. Students are encouraged to explore, ask questions, and build a strong base in subjects like mathematics, language, and science.",
  },
  {
    id: 3,
    title: "High School",
    slug: "high-school",
    description:
      "The High School program prepares students for future academic and career success. With advanced subjects, practical learning, and skill development, we help students become independent thinkers and responsible individuals.",
    image: "/images/offers/offering_high_school.webp",
    link: "/#",
    longDescription:
      "The High School program prepares students for future academic and career success. With advanced subjects, practical learning, and skill development, we help students become independent thinkers and responsible individuals.",
    longDescriptionSecond: "The High School program prepares students for future academic and career success. With advanced subjects, practical learning, and skill development, we help students become independent thinkers and responsible individuals.",
  },
 
];
